document.addEventListener('DOMContentLoaded', function() {
	document.querySelectorAll('.menu-btn').forEach(button => {
		button.addEventListener('click', event => {
		event.preventDefault();
		const nav = document.querySelector('.drawer-nav');
		nav.classList.toggle('active');
		document.body.style.overflow = 'hidden';
		document.body.classList.toggle('menu-open');
		});
	});

	document.querySelectorAll('.close-menu-btn').forEach(button => {
		button.addEventListener('click', event => {
			event.preventDefault();
			const nav = document.querySelector('.drawer-nav');
			nav.classList.remove('active');
			document.body.style.overflow = '';
			document.body.classList.remove('menu-open');
		});
	});
});